module.exports = __webpack_public_path__ + "static/media/bg-weighing-machine.a7ab93fe.png";